import React from 'react'
import { AppBar, Toolbar } from '@material-ui/core'
import Tripi from '../Tripi'

function Header(props) {

    return (
        <AppBar color='primary'>
            <Toolbar>
                <Tripi size={60} />
                <span style={{ fontSize: '2em' }}>&nbsp;&nbsp;Fractal Strategies</span>
            </Toolbar>
        </AppBar>
    )

}

export default Header
